import request from "@/utils/request";

/**
 * 套餐列表
 * @param pram
 */
export function productLstApi(params) {
  return request({
    url: "/shop/memplan/list",
    method: "GET",
    params,
  });
}
export function uploadImg(data) {
  return request({
    url: "/shop/upload/image",
    method: "POST",
    data,
  });
}
export function uploadVideo(data) {
  return request({
    url: "/shop/upload/uploadVideo",
    method: "POST",
    data,
  });
}

/**
 * 新增套餐
 * @param pram
 */
export function productCreateApi(data) {
  return request({
    url: "/shop/memplan/save",
    method: "POST",
    data,
  });
}
/**
 * 编辑套餐
 * @param pram
 */
export function productUpdateApi(data) {
  const param = {
    id: data.id,
  };
  return request({
    url: "/shop/memplan/update",
    method: "POST",
    params: param,
    data,
  });
}
export function productDeleteApi(id) {
  const data = {
    id: id,
  };
  return request({
    url: "/shop/memplan/delete",
    method: "POST",
    params: data,
  });
}
/**
 * 状态修改
 * @param pram
 */
export function changeStatus(data) {
  return request({
    url: `/shop/memplan/updateStatus`,
    method: "GET",
    params: data,
  });
}
/**
 * 推荐修改
 * @param pram
 */
export function updateRecommend(data) {
  return request({
    url: `/shop/memplan/updateRecommend`,
    method: "GET",
    params: data,
  });
}
/**
 * 套餐详情
 * @param pram
 */
export function productDetailApi(id) {
  return request({
    url: `/shop/memplan/${id}`,
    method: "GET",
  });
}

export function getRecordList(pram) {
  const data = {
    createTime: pram.createTime,
    updateTime: pram.updateTime,
    page: pram.page,
    limit: pram.limit,
    operatorId: pram.operatorId,
    status: pram.status,
  };
  return request({
    url: "/shop/memplan/record/list",
    method: "get",
    params: data,
  });
}
export function getDetail(pram) {
  return request({
    url: "/shop/memplan/record/" + pram,
    method: "get",
  });
}
export function changeRecordStatus(id, data) {
  return request({
    url: "/shop/memplan/record/changeStatus",
    method: "post",
    params: {
      id: id,
    },
    data,
  });
}
